import Footer from "@/components/Footer";
import Navigation from "@/components/Navigation";
export default function IvrSystemPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <section className="pt-20 bg-white relative overflow-hidden">
        <section className="relative overflow-hidden bg-gradient-to-br from-[#184fb8] via-[#1d62e6] to-[#2a7cff]">
          <div className="container mx-auto px-6 py-12 lg:py-16">
            <div className="grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <img
                  src="/ivr.png"
                  alt="IVR Illustration"
                  className="w-full max-w-md lg:max-w-lg mx-auto rounded-3xl shadow-[0_12px_32px_rgba(2,6,23,.10)] ring-1 ring-white/10 bg-white"
                />
              </div>
              <div className="text-white">
                <h1 className="text-3xl md:text-4xl font-black">
                  Hosted IVR Solution
                </h1>
                <p className="mt-4 text-white/90 leading-7">
                  As the customer touch points with your business increase, it
                  becomes critical for customers to get a consistent and
                  seamless experience across all touch points. With a Hosted IVR
                  solution, the customers are routed through an Automated
                  Interactive Voice Response unit where they can choose the
                  response they are looking for, while being guided through
                  various voice pre-recorded voice prompts. We offer a suite of
                  APIs to integrate with various third party applications for
                  building intelligent IVR systems or intelligent Dialer systems
                  as per your specific business need. Our APIs are system
                  agnostic and work in a simple way of request and response.
                </p>

                <ul className="mt-6 grid sm:grid-cols-2 gap-3 text-sm">
                  <li className="flex items-start gap-3">
                    <svg
                      className="h-5 w-5 mt-0.5 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="m5 12 4 4L19 6" />
                    </svg>
                    Bank and stock account balances and transfers
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      className="h-5 w-5 mt-0.5 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="m5 12 4 4L19 6" />
                    </svg>
                    Surveys and polls
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      className="h-5 w-5 mt-0.5 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="m5 12 4 4L19 6" />
                    </svg>
                    Office call routing
                  </li>
                  <li className="flex items-start gap-3">
                    <svg
                      className="h-5 w-5 mt-0.5 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="m5 12 4 4L19 6" />
                    </svg>
                    Call center forwarding
                  </li>
                  <li className="flex items-start gap-3 sm:col-span-2">
                    <svg
                      className="h-5 w-5 mt-0.5 text-white"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="m5 12 4 4L19 6" />
                    </svg>
                    Simple order entry transactions
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 grid gap-10 lg:grid-cols-2">
          <div className="space-y-6 leading-7 reveal">
            <p>
              IVR significantly increases first contact resolution because
              callers are always directed to the agent who is most capable of
              meeting their needs or the most appropriate department. The agent
              who receives the call will be more qualified to answer the
              caller’s question and will be less likely to transfer the call to
              another agent.
            </p>
            <p>
              Agents who work in a company that uses an IVR are more proficient
              at solving specific problems and meeting specific needs of the
              customers that they are assigned. The result is an increase in
              customer service efficiency.
            </p>
          </div>
          <div className="reveal">
            <img
              src="/ivr.jpg"
              alt="Agent on phone"
              className="w-full rounded-2xl shadow-[0_12px_32px_rgba(2,6,23,.10)] border border-slate-200"
            />
          </div>
        </section>
      </section>
      <Footer />
    </div>
  );
}
